import api from "./api";

export async function getPredictiveLogisticsData() {
    const response = await api.get("/PredictiveLogistics/dashboard");
    return response.data;
}